@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.gsb.vyapar.bhagya.util

import app.cash.sqldelight.async.coroutines.awaitCreate
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import com.gsb.vyapar.bhagya.datasource.cache.GsbVyaparBhagyaDatabase
import org.w3c.dom.Worker

actual class DatabaseDriverFactory {
    actual suspend fun createDriver(): SqlDriver {
        return WebWorkerDriver(
            Worker(
                js("""new URL("persistent-sqljs.worker.js", import.meta.url)""")
            )
        ).also { GsbVyaparBhagyaDatabase.Schema.awaitCreate(it) }
    }
}